import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const quoteToCustomer = async (data: any, quoteId: number) => {
  return await axiosInstance
    .patch(`quotes/toCustomer/${quoteId}`, data)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useQuoteToCustomer = () => {
  return useMutation({
    mutationFn: ({ data, quoteId }: { data: any; quoteId: number }) =>
      quoteToCustomer(data, quoteId),
    mutationKey: ["quotes"],
  });
};

export default useQuoteToCustomer;
